import { Navigate } from 'react-router-dom'
import { ReactNode } from 'react'

interface ProtectedRouteProps {
  children: ReactNode
}

function ProtectedRoute({ children }: ProtectedRouteProps) {
  // Check if admin is authenticated
  const isAuthenticated = sessionStorage.getItem('admin_authenticated') === 'true'
  const adminToken = sessionStorage.getItem('admin_token')
  const envToken = import.meta.env.VITE_ADMIN_TOKEN

  // Verify the stored token matches the environment variable
  const isValid = isAuthenticated && adminToken === envToken

  if (!isValid) {
    // Redirect to login if not authenticated
    return <Navigate to="/admin/login" replace />
  }

  return <>{children}</>
}

export default ProtectedRoute
